module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"congratulations":"おめでとうございます！","got_a_medal":"{medalName}"},"en":{"congratulations":"Congratulations!","got_a_medal":"{medalName}!"}}')
  delete Component.options._Ctor
}
